/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

import {ICellRendererParams, ITooltipParams} from "ag-grid-community"
import {
    CellClassParams,
    CellStyle,
} from "ag-grid-community/dist/lib/entities/colDef"
import _ from "lodash"

import exclamationMark from "../../../img/exclamation_mark_8x8.png"
import warning from "../../../img/warning_co.gif"
import warningExclamationMark from "../../../img/warning_exclamation_8x15.gif"
import TableCell from "../../models/tableCell"
import TableCellIcon from "../../models/tableCellIcon"

const getIcon = (cell: TableCell): string => {
    switch (cell.icon) {
        case TableCellIcon.Exclamation:
            return `<img src=${exclamationMark} alt="Exclamation mark"/> `
        case TableCellIcon.Warning:
            return `<img src=${warning} alt="Warning"/> `
        case TableCellIcon.WarningExclamation:
            return `<img src=${warningExclamationMark} alt="Warning and Exclamation mark"/> `
        default:
            return ""
    }
}

const getValue = (cell: TableCell) => _.escape(cell.value)

const getLinkOpeningTag = (cell: TableCell) =>
    cell.href ? `<a href="${cell.href}" target="_blank">` : ""

const getLinkClosingTag = (cell: TableCell) => (cell.href ? `<a/>` : "")

export const tableCellRenderer = (params: ICellRendererParams): string => {
    const cell: TableCell = params.value
    return cell
        ? `${getIcon(cell)}${getLinkOpeningTag(cell)}${getValue(
              cell
          )}${getLinkClosingTag(cell)}`
        : ""
}

export const tableCellCellStyle = (params: CellClassParams): CellStyle => {
    const cell: TableCell = params.value
    return cell
        ? (({
              ...(cell.italic && {fontStyle: "italic"}),
              ...(cell.backgroundColor && {
                  backgroundColor: cell.backgroundColor,
              }),
              ...(cell.textAlign && {textAlign: cell.textAlign}),
          } as React.CSSProperties) as CellStyle)
        : {}
}

export const tableCellCellClass = (params: CellClassParams): string => {
    const cell: TableCell = params.value
    return cell?.backgroundColor ? "has-background-color" : ""
}

export const tooltipValueGetter = (params: ITooltipParams): string => {
    const cell: TableCell = params.value
    return cell?.tooltip ?? ""
}
